


































import IWarehouse from '@/store/models/IWarehouse';
import IListPhonePrefix from '@/store/models/IListPhonePrefix';
import { Vue, Component, Watch } from 'vue-property-decorator';
import WarehouseApi from '../store/api/WarehouseApi';
import ListPhonePrefixesApi from '../store/api/ListPhonePrefixesApi';
import WarehouseSelector from '@/components/selectors/Warehouse/WarehouseSelector.vue';
import IListCountries from '@/store/models/IListCountries';
import ListCountriesApi from '@/store/api/ListCountriesApi';
import IWarehouseContacts from '@/store/models/IWarehouseContacts';
import WarehouseContactsApi from '@/store/api/WarehouseContactsApi';
import Snackbar from '@/components/shared/Snackbar.vue';
import ICompany from '@/store/models/ICompany';
import CompanyApi from '../store/api/CompanyApi';
import IAuthentication from '@/store/models/IAuthentication';
import IRolePermission from '@/store/models/IRolePermission';
@Component({
    components: {
        WarehouseSelector,
        Snackbar
    }
})
export default class Warehouses extends Vue {
    // CompanySelector
    WarehouseList : IWarehouse[] = [];
    warehouseApi : WarehouseApi;
    ListPhonePrefix : IListPhonePrefix[] = [];
    listPhonePrefixesApi : ListPhonePrefixesApi;
    phonePrefixCountry : string[] = [];
    selectedWarehouse : IWarehouse | null = null;
    idWarehouse : string = "";
    listCountriesApi : ListCountriesApi;
    idCompany : string = "";
    ListCountries : IListCountries[] = [];
    countryName : string[] = [];
    CompanyList : ICompany[] = [];
    CompanyApi : CompanyApi;
    overlay: boolean = false;
    WarehouseContactsList : IWarehouseContacts[] = [];
    warehouseContactsApi : WarehouseContactsApi;
    permissions : IRolePermission[] = [];

    constructor() {
        super();
        this.warehouseApi = new WarehouseApi();
        this.listPhonePrefixesApi = new ListPhonePrefixesApi();
        this.listCountriesApi = new ListCountriesApi();
        this.warehouseContactsApi = new WarehouseContactsApi();
        this.CompanyApi = new CompanyApi();
    }

    created() {
        this.getPermissions();
        this.getWarehouses();
        this.getListPhonePrefixes();
        this.getCountries();
        this.getCompanies();
    }

    warehouseChanged(warehouse: IWarehouse) {
        if (warehouse !== undefined && Object.keys(warehouse).length !== 0) {
            this.getWarehouseContacts(this.selectedWarehouse!.id);
        }
    }

    getPermissions() {
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idCompany = userFromStorage.idCompany;
        this.permissions.push(userFromStorage.rolePermissions.find(r => r.formName === "Warehouses"));
    }

    async getWarehouses() {
        this.WarehouseList = await this.warehouseApi.GetWarehousesByCompanyId(this.idCompany);
    }

    async getCompanies() {
        this.CompanyList = await this.CompanyApi.GetCompaniesById(this.idCompany);
    }

    async getListPhonePrefixes() {
        this.ListPhonePrefix = await this.listPhonePrefixesApi.GetListPhonePrefixes();
        if (this.ListPhonePrefix) {
            this.phonePrefixCountry = this.ListPhonePrefix.map(l => l.country);
        }
    }

    deleteWarehouse (item: IWarehouse) {
        confirm('Are you sure you want to delete this warehouse?') && this.deleteWarehouseItem(item);
    }

    async deleteWarehouseItem(warehouse: IWarehouse) {
        this.overlay = true;
        let result: boolean = await this.warehouseApi.DeleteWarehouse(warehouse.id);
        if (result) {
            const index = this.WarehouseList.indexOf(warehouse);
            this.WarehouseList.splice(index, 1);
            this.showMessageInfo(`The warehouse ${warehouse.name} has been successfully deleted`);
        } else {
            const errors: string = this.warehouseApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async saveWarehouse (warehouse: IWarehouse) {
        if (!warehouse.id) {
            this.overlay = true;
            warehouse.idCompany = this.idCompany;
            const id = await this.warehouseApi.SaveWarehouse(warehouse);
            if (id) {
                warehouse.id = id;
                this.WarehouseList = [warehouse].concat(this.WarehouseList);
                this.selectedWarehouse = warehouse;
                this.showMessageInfo(`The warehouse ${warehouse.name} has been successfully saved`);
            } else {
                const errors: string = this.warehouseApi.getModelError().join("; ");
                this.showMessageError(errors);
            }
            this.overlay = false;
        }
    }

    async editWarehouse (editedWarehouse: IWarehouse) {
        this.overlay = true;
        let result : boolean = await this.warehouseApi.UpdateWarehouse(editedWarehouse);
        if (result) {
            this.showMessageInfo(`The warehouse ${editedWarehouse.name} has been successfully edited`);
        } else {
            const errors: string = this.warehouseApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }
 
    async getCountries() {
        if (this.ListCountries.length === 0) {
            this.ListCountries = await this.listCountriesApi.GetListCountries();
            if (this.ListCountries) {
                this.countryName = this.ListCountries.map(l => l.countryName);
            }
        }
    }

    async getWarehouseContacts(warehouseId: string) {
        this.WarehouseContactsList = await this.warehouseContactsApi.GetWarehouseContacts(warehouseId);
    }

    deleteWarehouseContact (item: IWarehouseContacts) {
        confirm('Are you sure you want to delete this warehouse Contact?') && this.deleteWarehouseContactItem(item);
    }

    async deleteWarehouseContactItem(warehouseContact: IWarehouseContacts) {
        this.overlay = true;
        let result: boolean = await this.warehouseContactsApi.DeleteWarehouseContact(warehouseContact.id);
        if (result) {
            const index = this.WarehouseContactsList.indexOf(warehouseContact);
            this.WarehouseContactsList.splice(index, 1);
            this.showMessageInfo(`The warehouse contact has been successfully deleted`);
        } else {
            const errors: string = this.warehouseApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async saveWarehouseContact (warehouseContact: IWarehouseContacts) {
        this.overlay = true;
        warehouseContact.idWarehouse = this.selectedWarehouse!.id;
        const warehouseContactId = await this.warehouseContactsApi.SaveWarehouseContact(warehouseContact);
        if (warehouseContactId) {
            warehouseContact.id = warehouseContactId;
            this.WarehouseContactsList = [warehouseContact].concat(this.WarehouseContactsList);
            this.showMessageInfo(`The Warehouse contact has been successfully saved`);
        } else {
            const errors: string = this.warehouseApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async editWarehouseContact (editedWarehouseContact: IWarehouseContacts) {
        this.overlay = true;
        let result : boolean = await this.warehouseContactsApi.UpdateWarehouseContact(editedWarehouseContact);
        if (result) {
            this.showMessageInfo(`The warehouse contact has been successfully edited`);
        } else {
            const errors: string = this.warehouseApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    resetWarehouse() {
        this.selectedWarehouse = null;
        this.WarehouseContactsList = [];
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
